import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

import { createUserFeedback, updateUserFeedback } from './data';
import { useNotification } from '../../../../../shared/Notification/useNotification';

export const useCreateUserFeedbackMutation = setFeedbackId => {
  const { showError } = useNotification();
  const { t } = useTranslation('shared');

  const { mutate: createUserFeedbackMutation } = useMutation(
    createUserFeedback,
    {
      onSuccess: ({ data }) => {
        setFeedbackId(data.campaignUserFeedback.id);
      },
      onError: () => {
        showError({ content: t('errorText') });
      },
    },
  );

  return { createUserFeedbackMutation };
};

export const useUpdateUserFeedbackMutation = onClose => {
  const { showError, showSuccess } = useNotification();
  const { t } = useTranslation(['shared', 'campaigns']);

  const { mutate: updateUserFeedbackMutation } = useMutation(
    updateUserFeedback,
    {
      onSuccess: () => {
        if (onClose) {
          onClose();
        } else {
          Swal.close();
        }
        showSuccess({
          content: t('campaigns:feedback.notifySuccess'),
        });
      },
      onError: () => {
        showError({ content: t('shared:errorText') });
      },
    },
  );

  return { updateUserFeedbackMutation };
};
